import API from './api';

export const getWhiteboard = async () => {
  try {
    const response = await API.get('/whiteboard');
    return response.data;
  } catch (error) {
    console.error('Error fetching whiteboard content:', error);
    throw error;
  }
};

export const saveWhiteboard = async (content) => {
  try {
    const response = await API.post('/whiteboard', { content });
    return response.data;
  } catch (error) {
    console.error('Error saving whiteboard content:', error);
    throw error;
  }
};
